import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';

interface GlassCardProps extends HTMLMotionProps<'div'> {
    children: React.ReactNode;
    className?: string;
    hoverEffect?: boolean;
}

/**
 * A reusable component implementing the glassmorphism style.
 * Uses the .glass CSS class defined in tailwind.config.js
 */
const GlassCard = React.forwardRef<HTMLDivElement, GlassCardProps>(({
    children,
    className = '',
    hoverEffect = false,
    ...props
}, ref) => {
    return (
        <motion.div
            ref={ref}
            className={`glass rounded-2xl p-4 transition-all duration-300 ${className}`}
            whileHover={hoverEffect ? { scale: 1.02, backgroundColor: 'rgba(255, 255, 255, 0.85)' } : undefined}
            whileTap={hoverEffect ? { scale: 0.98 } : undefined}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            {...props}
        >
            {children}
        </motion.div>
    );
});

GlassCard.displayName = 'GlassCard';

export default GlassCard;
